import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatExpandableCardsDirective } from "@app/_directives/mat-expandable-cards.directive";
import { MatExpandableVirtualItemDirective } from "@app/_directives/mat-expandable-virtual-item.directive";
import { AngularExpansionModule } from "@app/angular-expansion/angular-expansion.module";
import { SatPopoverAnchoringService, SatPopoverModule } from "@ncstate/sat-popover";
import { ElRefDirective } from "./el-ref/el-ref.directive";
import { ExtractPipe } from "./extract.pipe";
import { IgnoreAutocompleteDirective } from "./ignore-autocomplete.directive";
import { IsBetaDirective } from "./is-beta.directive";
import { IsDevDirective } from "./is-dev.directive";
import { IsMatErrorDirective } from "./is-mat-error.directive";
import { IsSettingsEnabledDirective } from "./is-settings-enabled.directive";
import { LazyForDirective } from "./lazy-for.directive";
import { LongPressDirective } from "./long-press.directive";
import { OptionsScrollDirective } from "./mat-autocomplete-infinite-scroll.directive";
import { MatDividerMqDirective } from "./mat-divider-mq.directive";
import { MouseOverClassDirective } from "./mouse-over-class.directive";
import { AnchorForPopup } from "./satpopupfor-target.directive";
import { SendTagDirective } from "./send-tag";
import { TeamsExternaLinkDirective } from "./teams-externa-link.directive";
import { TeamsUiConditionDirective } from "./teams-ui-condition.directive";
import { TrackPropDirective } from "./track-prop.directive";

@NgModule({
	declarations: [
		AnchorForPopup,
		OptionsScrollDirective,
		ExtractPipe,
		ElRefDirective,
		LazyForDirective,
		TeamsUiConditionDirective,
		TeamsExternaLinkDirective,
		MouseOverClassDirective,
		LongPressDirective,
		SendTagDirective,
		IsBetaDirective,
		IsDevDirective,
		MatDividerMqDirective,
		IgnoreAutocompleteDirective,
		TrackPropDirective,
		IsMatErrorDirective,
		IsSettingsEnabledDirective,
		MatExpandableCardsDirective,
		MatExpandableVirtualItemDirective,
	],
	exports: [
		AnchorForPopup,
		OptionsScrollDirective,
		ExtractPipe,
		ElRefDirective,
		LazyForDirective,
		TeamsUiConditionDirective,
		TeamsExternaLinkDirective,
		SendTagDirective,
		MouseOverClassDirective,
		LongPressDirective,
		IsBetaDirective,
		IsDevDirective,
		MatDividerMqDirective,
		IgnoreAutocompleteDirective,
		TrackPropDirective,
		IsMatErrorDirective,
		IsSettingsEnabledDirective,
		MatExpandableCardsDirective,
		MatExpandableVirtualItemDirective,
	],
	imports: [CommonModule, AngularExpansionModule, SatPopoverModule],
	providers: [SatPopoverAnchoringService],
})
export class CustomDirectivesModule {}
